import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertArray',
  standalone: true,
})
export class ConvertArrayPipe implements PipeTransform {
  transform(value: any[]): any[] {
    let uniqueArray: any[] = [];
    if (value !== null && value !== undefined && Array.isArray(value)) {
      uniqueArray = value;
    }
    else {
      uniqueArray.push(value);
    }
    return uniqueArray;
  }
}
